export const ROUTER_RESET_STATE = 'ROUTER_RESET_STATE';
export const ROUTER_CURRENT_ITEM = 'ROUTER_CURRENT_ITEM';

export const ROUTER_REQUEST_LOADING = 'ROUTER_REQUEST_LOADING';
export const ROUTER_REQUEST_SUCCESS = 'ROUTER_REQUEST_SUCCESS';
export const ROUTER_REQUEST_FAILED = 'ROUTER_REQUEST_FAILED';

export const ROUTER_CURRENT_ACTION = 'ROUTER_CURRENT_ACTION';
export const ROUTER_RESET_ACTION = 'ROUTER_RESET_ACTION';

export const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';
export const SET_ACCOUNT_TYPES = 'SET_ACCOUNT_TYPES';

export const SET_GUEST_APPLICATION = 'SET_GUEST_APPLICATION';
export const SET_B2C_APPLICATION = 'SET_B2C_APPLICATION';
export const SET_B2B_APPLICATION = 'SET_B2B_APPLICATION';
export const SET_SCP_APPLICATION = 'SET_SCP_APPLICATION';
export const SET_SERVICE_APPLICATION = 'SET_SERVICE_APPLICATION';
export const SET_MANAGEMENT_APPLICATION = 'SET_MANAGEMENT_APPLICATION';

export const SET_IS_B2C_AUTHENTICATED = 'SET_IS_B2C_AUTHENTICATED';
export const SET_IS_B2B_AUTHENTICATED = 'SET_IS_B2B_AUTHENTICATED';
export const SET_IS_SCP_AUTHENTICATED = 'SET_IS_SCP_AUTHENTICATED';
export const SET_IS_SERVICE_AUTHENTICATED = 'SET_IS_SERVICE_AUTHENTICATED';
export const SET_IS_MANAGEMENT_AUTHENTICATED = 'SET_IS_MANAGEMENT_AUTHENTICATED';

